import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ColDef, GridApi, GridOptions } from "ag-grid-community";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { JSIGNALBUTTON } from "src/app/shared/common/JsignalButtons";
import { DeviationService } from "src/app/shared/services/deviation.service";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";

@Component({
    selector: "app-root-cause",
    templateUrl: "./root-cause.component.html",
    styleUrls: ["./root-cause.component.scss"],
    standalone: false
})
export class RootCauseComponent implements OnInit {
  @Input() rootCauses: any[] = [];
  @Input() deviationId?: number;

  @Output() rootCausesChange = new EventEmitter<any[]>();
  @Output() formOpenChange = new EventEmitter<boolean>();

  rootCauseForm: FormGroup;
  gridOptions: GridOptions = {};
  gridApi!: GridApi;

  columnDefs: ColDef[] = [];
  defaultColDef: ColDef = {};
  backgroundColorButton = "";
  components: any;

  showForm = false;

  isEditMode = false;
  selectedRootCauseId: string | null = null;

  causeType: any[] = [
    { id: 1, lookupvalue: "Root" },
    { id: 2, lookupvalue: "Probable" },
    { id: 3, lookupvalue: "Contributing" },
    { id: 4, lookupvalue: "Inconclusive" },
  ];
  Category: any[] = [
    { id: 1, lookupvalue: "Documentation error" },
    { id: 2, lookupvalue: "Human error" },
    { id: 3, lookupvalue: "System/software errors" },
  ];
  SubCategory: any[] = [
    { id: 1, lookupvalue: "Miscommunication" },
    { id: 2, lookupvalue: "Procedure not followed" },
    { id: 3, lookupvalue: "Incorrect documentation" },
    { id: 4, lookupvalue: "Equipment Maintenance" },
  ];
  rootCauseAnalysisType: any[] = [
    { id: 1, lookupvalue: "Barrier Analysis" },
    { id: 2, lookupvalue: "Change Analysis" },
  ];
private readonly LS_DEVIATION_ID = 'ACTIVE_DEVIATION_ID';

  constructor(
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private dialog: MatDialog,
    private jsignalsService: JsignalService,
    private deviationService: DeviationService,
    private localStorageSettings: LocalStorageSettingsService,
    private fb: FormBuilder
  ) {
    this.components = {
      jsignalButton: JSIGNALBUTTON,
    };
  }

  ngOnInit(): void {
    this.initializeGrid();
    this.createRootCauseForm();
    this.loadRootCauses();
  }



  initializeGrid() {
    // Set theme colors
    this.backgroundColorButton =
      this.localStorageSettings.getSettings("ColorA");
    this.columnDefs = [
      {
        headerName: "Action",
        sortable: false,
        filter: false,
        resizable: false,
        cellRenderer: "jsignalButton",
        pinned: "left",
        lockPinned: true,
        cellRendererParams: (params: any) => ({
          //below value is passed to button to hide check box for deleted rows
          disableCheckBox: params.data?.status === "No",
          PopUpEdit: this.EditIcon.bind(this),
          PopUpDelete: this.deleteIcon.bind(this),
        }),
      },
      {
        headerName: "Name",
        field: "rootCauseName",
        ...this.jsignalsService.autoTooltip("Name"),
      },
      {
        headerName: "Cause Type",
        field: "causeType",
        ...this.jsignalsService.autoTooltip("Cause Type"),
      },
      {
        headerName: "Category",
        field: "category",
        ...this.jsignalsService.autoTooltip("Category"),
      },
      {
        headerName: "Sub Category",
        field: "subCategory",
        ...this.jsignalsService.autoTooltip("Sub Category"),
      },
      {
        headerName: "Analysis Type",
        field: "rootCauseAnalysisType",
        ...this.jsignalsService.autoTooltip("Analysis Type"),
      },
      {
        headerName: "Description",
        field: "rootCauseDescription",
        ...this.jsignalsService.autoTooltip("Description"),
      },
      {
        headerName: "Analysis",
        field: "rootCauseAnalysis",
        ...this.jsignalsService.autoTooltip("Analysis"),
      },
    ];
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      filter: true,
      resizable: true,
    };

    this.gridOptions = {
      rowHeight: 40,
    };
  }

  createRootCauseForm() {
    this.rootCauseForm = this.fb.group({
      rootCauseName: ["", Validators.required],
      causeType: ["", Validators.required],
      category: ["", Validators.required],
      subCategory: [""],
      rootCauseDescription: ["", Validators.required],
      rootCauseAnalysis: [""],
      rootCauseAnalysisType: [""],
    });
  }

private loadRootCauses(): void {
  const deviationId = this.deviationId || localStorage.getItem(this.LS_DEVIATION_ID);
  console.log(deviationId);

  if (!deviationId) {
    this.snackBar.open(
      'Deviation must be saved before adding Root Causes.',
      'Ok',
      { duration: 4000 }
    );
    return;
  }

  this.spinner.start();

  this.deviationService.getRootCauses(deviationId).subscribe({
    next: (res:any) => {

      if (res.error) {
        this.handleFailure(res); //backend message shown
        return;
      }

      this.spinner.stop();

      this.rootCauses = res || [];
      // this.rootCausesChange.emit(this.rootCauses);

      if (this.gridApi) {
        this.gridApi.setGridOption('rowData', this.rootCauses);
      }
    },
    error: () => {
      this.spinner.stop();
      this.handleFailure();
    }
  });
}


  addRootCause() {
      this.isEditMode = false;
     this.selectedRootCauseId = null;
    // this.rootCauseForm.reset();
    this.showForm = true; // hide grid, show form
    this.formOpenChange.emit(true); // hide parent button when form is open
  }

saveRootCause(): void {

  if (this.rootCauseForm.invalid) {
    this.rootCauseForm.markAllAsTouched();
    return;
  }

  const payload = this.rootCauseForm.value;
  console.log(payload);

  this.spinner.start();

  if (this.isEditMode) {
    this.updateRootCause(payload);
  } else {
    this.createRootCause(payload);
  }

    // this.rootCausesChange.emit(this.rootCauses);

    this.showForm = false;
    this.formOpenChange.emit(false);

    this.rootCauseForm.reset();

    this.gridApi.setGridOption('rowData', this.rootCauses);
    this.spinner.stop();
  }

  private createRootCause(payload: any): void {

  this.deviationService
    .addRootCauses(this.deviationId, [payload])
    .subscribe({
      next: (res:any) => {

      if (res.error) {
        this.afterFailure(res); //backend message shown
        return;
      }
        this.afterSuccess(res)
      },
      error: () => this.afterFailure()
    });
}

private updateRootCause(payload: any): void {

  if (!this.selectedRootCauseId) return;

  this.deviationService
    .updateRootCause(this.deviationId, this.selectedRootCauseId, payload)
    .subscribe({
      next: (res:any) => {

        if (res.error) {
        this.afterFailure(res); //backend message shown
        return;
      }
        this.afterSuccess(res)
      },
      error: () => this.afterFailure()
    });
}


  cancelForm() {
    this.resetForm();
    this.rootCauseForm.reset();
    this.showForm = false;
    this.formOpenChange.emit(false);
  }

  // deleteIcon(params: any) {
  //   const rowData = params.rowData; // extract correctly

  //   console.log("Deleting row:", rowData);

  //   this.rootCauses = this.rootCauses.filter((rc) => rc !== rowData);

  //   this.rootCausesChange.emit(this.rootCauses);
  //   this.gridApi.setGridOption('rowData', this.rootCauses);
  // }

  deleteIcon(params: any): void {

  const row = params.rowData;
  if (!row?.id) return;

  this.spinner.start();

  this.deviationService
    .deleteRootCause(this.deviationId, row.id)
    .subscribe({
      next: (res:any) => {
      if (res.error) {
        this.afterFailure(res); //backend message shown
        return;
      }
        this.afterSuccess(res)
        this.loadRootCauses()
      },
      error: () => this.spinner.stop()
    });
}

private afterSuccess(res:any): void {
  this.spinner.stop();
  this.resetForm();
    if (res && res.error === false) {
    this.snackBar.open(res.statusMessage, 'Ok', {
      duration: 3000
    });
  }
  this.loadRootCauses();

}

private resetForm(): void {
  this.showForm = false;
  this.isEditMode = false;
  this.selectedRootCauseId = null;
  this.rootCauseForm.reset();
  this.formOpenChange.emit(false);
}


private afterFailure(res?: any): void {
   this.spinner.stop();

  const message =
    res?.statusMessage ||
    'Operation failed. Please try again.';

  this.snackBar.open(message, 'Ok', {
    duration: 4000
  });
  this.spinner.stop();
}


EditIcon(params: any): void {

  const row = params.rowData;
  if (!row) return;

  this.isEditMode = true;
  this.selectedRootCauseId = row.id;

  this.rootCauseForm.patchValue({
    rootCauseName: row.rootCauseName,
    causeType: row.causeType,
    category: row.category,
    subCategory: row.subCategory,
    rootCauseDescription: row.rootCauseDescription,
    rootCauseAnalysis: row.rootCauseAnalysis,
    rootCauseAnalysisType: row.rootCauseAnalysisType
  });

  this.showForm = true;
  this.formOpenChange.emit(true);
}


  onGridReady(params: any) {
    this.gridApi = params.api;
  }

  private handleFailure(res?: any): void {
  this.spinner.stop();

  const message =
    res?.statusMessage ||
    'Operation failed. Please try again.';

  this.snackBar.open(message, 'Ok', {
    duration: 4000
  });

  this.clearDeviationState();
}

clearDeviationState() {
  localStorage.removeItem(this.LS_DEVIATION_ID);
  this.rootCauses = [];
}
private handleSuccess(res: any): void {
  if (res && res.error === false) {
    this.snackBar.open(res.statusMessage, 'Ok', {
      duration: 3000
    });
  }
}
errorStateMatcher = {
  isErrorState: (control: any) => {
    return !!(
      control &&
      control.invalid &&
      (control.touched || control.dirty)
    );
  }
};

}
